import {
  AdvancedAnalysisItemComplianceModuleAssignmentFieldsFragment,
  ComplianceModuleFieldsFragment,
  ComplianceOperationItemComplianceModuleAssignmentFieldsFragment,
  TopicComplianceModuleAssignmentFieldsFragment,
} from '../../../../../../../../../../generated/core-api/graphql-react-query';

export function isTopicComplianceModuleAssignment(assignment: any): assignment is TopicComplianceModuleAssignmentFieldsFragment {
  return assignment.__typename === 'TopicComplianceModuleAssignment';
}

export function isAdvancedAnalysisItemComplianceModuleAssignment(assignment: any): assignment is AdvancedAnalysisItemComplianceModuleAssignmentFieldsFragment {
  return assignment.__typename === 'AdvancedAnalysisItemComplianceModuleAssignment';
}

export function isComplianceOperationItemComplianceModuleAssignment(assignment: any): assignment is ComplianceOperationItemComplianceModuleAssignmentFieldsFragment {
  return assignment.__typename === 'ComplianceOperationItemComplianceModuleAssignment';
}

export default function useTopicComplianceModuleMap(complianceModules: ComplianceModuleFieldsFragment[]) {
  const map = new Map<string, ComplianceModuleFieldsFragment>();
  complianceModules.forEach((module) => {
    module.assignedTopics.items.forEach((item) => {
      if (isTopicComplianceModuleAssignment(item)) {
        if (!map.has(item.assigneeId)) {
          map.set(item.assigneeId, module);
        }
      }
    });
  });
  return map;
}

export function useComplianceOperationItemComplianceModuleMap(complianceModules: ComplianceModuleFieldsFragment[]) {
  const map = new Map<string, ComplianceModuleFieldsFragment>();
  complianceModules.forEach((module) => {
    module.assignedOperationItems.items.forEach((item) => {
      if (isComplianceOperationItemComplianceModuleAssignment(item)) {
        if (!map.has(item.assigneeId)) {
          map.set(item.assigneeId, module);
        }
      }
    });
  });
  return map;
}

export function useAdvancedAnalysisItemComplianceModuleMap(complianceModules: ComplianceModuleFieldsFragment[]) {
  const map = new Map<string, ComplianceModuleFieldsFragment>();
  complianceModules.forEach((module) => {
    module.assignedAdvancedAnalysisItems.items.forEach((item) => {
      if (isAdvancedAnalysisItemComplianceModuleAssignment(item)) {
        if (!map.has(item.assigneeId)) {
          map.set(item.assigneeId, module);
        }
      }
    });
  });
  return map;
}
